import { useState, useEffect } from 'react'
import TeacherHeader from '../header'
import TeacherSidebar from '../sidebar'
import { Icon1, Icon2, User4, course04 } from '../../imagepath'
import { Link } from 'react-router-dom'
import PaymentServices from "../../../services/PaymentServices";
const TeacherOrderHistory = () => {
    const [apiResponse, setApiResponse] = useState(null);
    useEffect(() => {
        const fetchPayments = async () => {
          try {
            const response = await PaymentServices.getPaymentHistory();
            console.log("API Response:", response);
            
            if (response && response.payments) {
              setApiResponse(response);
            }
          } catch (error) {
            console.error("Error fetching videos:", error);
          }
        };
    
        fetchPayments();
      }, []);
    return (
        <>-
            {/* Main Wrapper */}
            <div className="main-wrapper">
                {/* Header */}
                <TeacherHeader activeMenu={"Dashboard"} />
                {/* /Header */}
                {/* Breadcrumb */}
                <div className="breadcrumb-bar breadcrumb-bar-info">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <div className="breadcrumb-list">
                                    <h2 className="breadcrumb-title">Teacher Order History</h2>
                                    <nav aria-label="breadcrumb" className="page-breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <Link to="/home">Home</Link>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">
                                                Dashboard
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /Breadcrumb */}
                {/* Page Content */}
                <div className="page-content">
                    <div className="container">
                        <div className="row">
                            {/* sidebar */}
                            <TeacherSidebar />
                            {/* /Sidebar */}
                            {/* School Dashboard */}
                            <div className="col-xl-9 col-lg-9">
                                {/* Dashboard Grid */}
                                <div className="table-responsive custom-table">
                              <table id="orderHistoryTable" className="table table-nowrap mb-0">
                                            <thead>
                                            <tr>
                                                <th></th>
                                                {/* <th>School Name</th> */}
                                                <th>Payment</th>
                                                <th>Payment Method</th>
                                                <th>Payment Date</th>
                                                <th />
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(apiResponse) ? apiResponse.payments.map((payment,index) => (
                                            <tr key={payment._id}>
                                                <td>{index + 1}</td>
                                                {/* <td>
                                                <span className="title-course">
                                                  {school.name}
                                                </span>
                                                </td> */}
                                              <td>  {payment?.amount
                                ? `$${payment.amount.toFixed(2)}`
                                : "N/A"}</td> 
                                                <td>{payment?.amount ? payment.method : "N/A"}</td>
                                                <td>{payment?.startDate
                                ? new Date(
                                    payment.startDate
                                  ).toLocaleString()
                                : "N/A"}</td>
                                                <td>
                                               
                                                </td>
                                            </tr>
                                            )) : ''}
                                            </tbody>
                                        </table>
                                </div>
                     
                            {/* <div className="dash-pagination">
                  <div className="row align-items-center">
                    <div className="col-6">
                      <p>Page 1 of 2</p>
                    </div>
                    <div className="col-6">
                      <ul className="pagination">
                        <li className="active">
                          <Link to="#">1</Link>
                        </li>
                        <li>
                          <Link to="#">2</Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="bx bx-chevron-right" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div> */}
                            </div>
                            {/* School Dashboard */}
                        </div>
                    </div>
                </div>
                {/* /Page Content */}
                {/* Footer */}

                {/* /Footer */}
            </div>
            {/* /Main Wrapper */}
        </>

    )
}

export default TeacherOrderHistory
